import { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import PropTypes from 'prop-types';

/**
 * Binds react-router to the app-owned history instance (Initialiser.history) so
 * Redux thunks and the axios interceptor can navigate imperatively from outside
 * the component tree. Equivalent to react-router's unstable_HistoryRouter, but
 * owned by us so it survives router major bumps.
 */
export default function HistoryRouter({ history, children }) {
    const [state, setState] = useState({ action: history.action, location: history.location });

    // history v5 listen emits { action, location } — exactly the state shape we need.
    useLayoutEffect(() => history.listen(setState), [history]);

    return (
        <Router navigator={history} location={state.location} navigationType={state.action}>
            {children}
        </Router>
    );
}

HistoryRouter.propTypes = {
    history: PropTypes.object.isRequired,
    children: PropTypes.node,
};
